import { Link } from 'react-router-dom';
import LinkItem from 'components/common/Link';
import { getImageUrl } from 'helpers';



const UseCaseItem = ({ data }) => {
    const {
        // id,
        title,
        text,
        learn_more_text,
        small_card,
        learn_more_link,
        image } = data

    const Image = getImageUrl(image)

    return learn_more_link ? (
        <Link
            to={learn_more_link}
            className={`usecase-cases-item ${small_card ? "usecase-cases-item--small" : "usecase-cases-item--big"}`}
        >
            <div className="usecase-cases-item__img">
                <img src={Image} alt="" />
            </div>
            <div className="usecase-cases-item__body">
                <div className="description2">{title}</div>
                <div className="body2">{text}</div>
                {learn_more_link && <LinkItem text={learn_more_text} />}
            </div>
        </Link>
    ) : (
        <div
            className={`usecase-cases-item ${small_card ? "usecase-cases-item--small" : "usecase-cases-item--big"} `}
        >
            <div className="usecase-cases-item__img">
                <img src={Image} alt="" />
            </div>
            <div className="usecase-cases-item__body">
                <div className="description2">{title}</div>
                <div className="body2">{text}</div>
            </div>
        </div>
    );
};

export default UseCaseItem;
